import axios from 'axios'
export default {
	namespaced: true,
	state: {
		endpoint: '/document/status/type',
		name: 'DocumentStatusType',
		title: {
			single: 'DocumentStatusType',
			plural: 'DocumentStatusTypes'
		},
		icon: 'mdi-format-list-bulleted-type',
		items: [],
	},
	actions: {
		load (context, data) {
			return axios.get(context.getters.endpoint).then(response => {
				context.commit('items', response.data)
			}, error => {
				console.log('error', error)
			})
		},
	},
}
